import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AppState } from '@app/store';
import { searchSuggestions } from '@app/services/api.service';
import { SuggestionModel } from '@models/Suggestion/Suggestion.model';
import {
  setSuggestions,
  clearSuggestions,
  setCount,
  clearCount,
  startLoading,
  finishLoading,
} from './actions';
import { Suggestion } from '@app/models/Suggestion/Suggestion.interface';

export const loadSuggestions =
  ({
    value,
  }: {
    value: string;
  }): ThunkAction<void, AppState, null, Action<string>> =>
  async (dispatch, getState) => {
    dispatch(startLoading());
    dispatch(clearCount());
    dispatch(clearSuggestions());

    const suggestionsRes = searchSuggestions(value);
    suggestionsRes.then((res) => {
      if (res._meta && res._meta.currentPage < res._meta.pageCount) {
        dispatch(setCount(res._meta.totalCount - res._meta.perPage));
      } else {
        dispatch(clearCount());
      }

      const suggestions: SuggestionModel[] = [];

      res.results.forEach((suggestion: Suggestion) =>
        suggestions.push(new SuggestionModel(suggestion))
      );

      if (
        getState().search.moreCount &&
        res._meta &&
        res._meta.totalCount > 0
      ) {
        suggestions.push(new SuggestionModel({ isCount: true, title: value }));
      }

      dispatch(setSuggestions(suggestions));
      dispatch(finishLoading());
    });
  };
